import React from 'react';
// import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Drink from '@assets/drink.png';
import { useStyles } from './styles';

function DrinkHistoryCard({ srcImg, title }) {
  const classes = useStyles();
  // const { t } = useTranslation('drinksHistory');

  // ? Function for generate
  // ? random quantity of ordered cocktails
  // const randomInteger = ({ min, max }) => {
  //   const rand = min + Math.random() * (max + 1 - min);
  //   return Math.floor(rand);
  // };

  // ? Quantity of ordered cocktails
  // const qtyCocktail = randomInteger({ min: 1, max: 6 });

  return (
    <Box className={classes.card}>
      <img src={Drink} alt="" className={classes.imgCard} />
      <Typography className={classes.title}>The Other Woman</Typography>
      <Typography className={classes.quantity}>
        {/* {qtyCocktail} {qtyCocktail > 1 ? t('cocktails') : t('cocktail')} */}
        2 cocktails
      </Typography>
    </Box>
  );
}

export default DrinkHistoryCard;
